<div class="user-dashboard-container">
  <div class="dashboard-content">
    <!-- Header simple et professionnel -->
    <div class="dashboard-header">
      <div class="header-content">
        <h1>Utilisateurs</h1>
        <p class="dashboard-subtitle">{{ filteredUsers.length }} utilisateur(s)</p>
      </div>
    </div>

    <!-- Actions -->
    <p-card styleClass="actions-card">
      <ng-template pTemplate="content">
<!-- Remplacer la section des actions par ceci -->
      <div class="actions-bar">
        <div class="search-section">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText 
                  type="text" 
                  [(ngModel)]="searchTerm" 
                  placeholder="Rechercher..." 
                  (ngModelChange)="onSearchChange($event)" />
          </span>
        </div>
        
        <div class="filter-section">
          <p-dropdown [options]="statusFilter" 
                      [(ngModel)]="selectedStatus" 
                      placeholder="Statut" 
                      (onChange)="onStatusChange()" 
                      [showClear]="true"></p-dropdown>
        </div>
        
        <div class="action-buttons">
          <p-button icon="pi pi-plus" 
                    (onClick)="showAddUserDialog = true"
                    styleClass="p-button-success"
                    pTooltip="Ajouter"></p-button>

          <p-button icon="pi pi-refresh" 
                    (onClick)="loadUsers()"
                    [loading]="loading"
                    pTooltip="Actualiser"></p-button>
        </div>
      </div>
      </ng-template>
    </p-card>

    <!-- Messages -->
    <p-messages *ngIf="error" severity="error" [value]="[{detail: error}]"></p-messages>
    <p-messages *ngIf="successMessage" severity="success" [value]="[{detail: successMessage}]"></p-messages>

    <!-- Table -->
    <div class="table-container">
      <p-table [value]="filteredUsers" 
               [loading]="loading" 
               [paginator]="true" 
               [rows]="10" 
               [rowsPerPageOptions]="[5,10,20]"
               responsiveLayout="scroll"
               selectionMode="multiple" 
               [(selection)]="selectedUsers"
               dataKey="id">

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Utilisateur</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>Rôle</th>
            <th>HubSpot ID</th>
            <th>Statut</th>
            <th>Créé le</th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user>
          <tr [pSelectableRow]="user">
            <td>
              <p-tableCheckbox [value]="user"></p-tableCheckbox>
            </td>
            <td>
              <div class="user-info">
                <div class="user-avatar" [class]="user.role">
                  {{ getInitials(user.username || user.email) }}
                </div>
                <div class="user-details-text">
                  <div class="user-name">{{ getUsername(user) }}</div>
                  <div class="user-email">{{ user.email }}</div>
                </div>
              </div>
            </td>
            <td>
              <a [href]="'mailto:' + user.email" class="email-link">
                {{ user.email }}
              </a>
            </td>
            <td>
              <span *ngIf="user.telephone; else noPhone" class="phone-number" style="display: flex; align-items: center;">
                {{ user.telephone }}
                <app-ringover-widget [telephone]="user.telephone"></app-ringover-widget>
              </span>
              <ng-template #noPhone>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td>
              <p-tag [value]="getRoleLabel(user.role)" 
                     [severity]="getRoleSeverity(user.role)">
              </p-tag>
            </td>
            <td>
              <span *ngIf="user.hubspot_id; else noHubspot" class="hubspot-id">
                {{ user.hubspot_id }}
              </span>
              <ng-template #noHubspot>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td>
              <p-tag [value]="user.is_active ? 'Actif' : 'Suspendu'" 
                     [severity]="user.is_active ? 'success' : 'danger'">
              </p-tag>
            </td>
            <td>
              <span *ngIf="getCreatedDate(user); else noDate" class="created-date">
                {{ formatDate(getCreatedDate(user)) }}
              </span>
              <ng-template #noDate>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td>
              <div class="action-buttons">
                <p-button icon="pi pi-eye" 
                          pTooltip="Voir"
                          (onClick)="viewUserDetails(user)"
                          styleClass="p-button-text p-button-info"></p-button>
                <p-button icon="pi pi-pencil" 
                          pTooltip="Modifier"
                          (onClick)="editUser(user)"
                          styleClass="p-button-text p-button-warning"></p-button>
                <p-button [icon]="user.is_active ? 'pi pi-ban' : 'pi pi-check'" 
                          [pTooltip]="user.is_active ? 'Suspendre' : 'Activer'"
                          (onClick)="toggleUserStatus(user)"
                          [styleClass]="user.is_active ? 'p-button-text p-button-warning' : 'p-button-text p-button-success'"></p-button>
                <p-button icon="pi pi-trash" 
                          pTooltip="Supprimer"
                          (onClick)="confirmDelete(user)"
                          styleClass="p-button-text p-button-danger"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9">
              <div class="empty-state">
                <i class="pi pi-users"></i>
                <h3>Aucun utilisateur</h3>
                <p>Commencez par ajouter votre premier utilisateur</p>
                <p-button label="Ajouter un utilisateur" 
                          icon="pi pi-plus" 
                          (onClick)="showAddUserDialog = true"
                          styleClass="p-button-success"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<!-- Ajouter à la fin du fichier, après la table et avant p-confirmDialog -->

<!-- Dialog d'ajout d'utilisateur amélioré -->
<p-dialog [(visible)]="showAddUserDialog" 
          [modal]="true" 
          [style]="{width: '600px'}" 
          [closable]="true"
          [draggable]="false"
          [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-user-plus" style="font-size: 1.5rem; color: #3498db; margin-right: 12px;"></i>
      <div>
        <h3 style="margin: 0; color: #2c3e50; font-size: 1.3rem;">Ajouter un utilisateur</h3>
        <p style="margin: 4px 0 0 0; color: #6c757d; font-size: 0.85rem;">Créez un nouveau compte utilisateur</p>
      </div>
    </div>
  </ng-template>
  
  <ng-template pTemplate="content">
    <form [formGroup]="addUserForm" (ngSubmit)="addUser()" class="modern-form">
      <div class="form-grid">
        <!-- Section Informations personnelles -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-id-card"></i>
            <span>Informations personnelles</span>
          </div>
          
          <div class="field-with-icon">
            <label for="username" class="field-label">
              <i class="pi pi-user"></i>
              Nom d'utilisateur *
            </label>
            <input pInputText 
                   id="username" 
                   formControlName="username" 
                   placeholder="Ex: jean.dupont"
                   class="input-with-icon" />
            <small *ngIf="addUserForm.get('username')?.errors?.['required'] && addUserForm.get('username')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Le nom d'utilisateur est obligatoire
            </small>
            <small *ngIf="addUserForm.get('username')?.errors?.['minlength'] && addUserForm.get('username')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Minimum 3 caractères requis
            </small>
          </div>
          
          <div class="field-with-icon">
            <label for="email" class="field-label">
              <i class="pi pi-envelope"></i>
              Email professionnel *
            </label>
            <input pInputText 
                   id="email" 
                   formControlName="email" 
                   type="email" 
                   placeholder="exemple@entreprise.com"
                   class="input-with-icon" />
            <small *ngIf="addUserForm.get('email')?.errors?.['required'] && addUserForm.get('email')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> L'email est obligatoire
            </small>
            <small *ngIf="addUserForm.get('email')?.errors?.['email'] && addUserForm.get('email')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Format d'email invalide
            </small>
          </div>
          
          <div class="field-with-icon">
            <label for="telephone" class="field-label">
              <i class="pi pi-phone"></i>
              Téléphone
            </label>
            <input pInputText 
                   id="telephone" 
                   formControlName="telephone" 
                   type="tel" 
                   placeholder="+33 6 12 34 56 78"
                   class="input-with-icon" />
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Numéro de contact optionnel
            </small>
          </div>
        </div>

        <!-- Section Sécurité -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-lock"></i>
            <span>Sécurité et accès</span>
          </div>
          
          <div class="field-with-icon">
            <label for="password" class="field-label">
              <i class="pi pi-key"></i>
              Mot de passe *
            </label>
            <input pInputText 
                   id="password" 
                   formControlName="password" 
                   type="password" 
                   placeholder="••••••••"
                   class="input-with-icon" />
            <small *ngIf="addUserForm.get('password')?.errors?.['required'] && addUserForm.get('password')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Le mot de passe est obligatoire
            </small>
            <small *ngIf="addUserForm.get('password')?.errors?.['minlength'] && addUserForm.get('password')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Minimum 6 caractères requis
            </small>
            <small *ngIf="!addUserForm.get('password')?.errors && addUserForm.get('password')?.value" 
                   class="field-success">
              <i class="pi pi-check-circle"></i> Mot de passe valide
            </small>
          </div>
          
          <div class="field-with-icon">
            <label for="role" class="field-label">
              <i class="pi pi-shield"></i>
              Rôle *
            </label>
            <p-dropdown formControlName="role" 
                        [options]="roleOptions" 
                        optionLabel="label" 
                        optionValue="value"
                        placeholder="Sélectionner un rôle"
                        id="role"
                        [style]="{'width': '100%'}"></p-dropdown>
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Définit les permissions de l'utilisateur
            </small>
          </div>
        </div>

        <!-- Section Intégration -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-link"></i>
            <span>Intégrations</span>
          </div>
          
          <div class="field-with-icon">
            <label for="hubspot_id" class="field-label">
              <i class="pi pi-database"></i>
              ID HubSpot
            </label>
            <input pInputText 
                   id="hubspot_id" 
                   formControlName="hubspot_id" 
                   placeholder="ID de contact HubSpot"
                   class="input-with-icon" />
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Optionnel - Pour synchronisation CRM
            </small>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
  
  <ng-template pTemplate="footer">
    <div class="dialog-footer-custom">
      <p-button label="Annuler" 
                icon="pi pi-times" 
                (onClick)="closeAddUserDialog()" 
                styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Créer l'utilisateur" 
                icon="pi pi-check" 
                (onClick)="addUser()" 
                [disabled]="addUserForm.invalid"
                [loading]="addingUser"
                styleClass="p-button-success"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog de détails utilisateur - Design professionnel -->
<p-dialog [(visible)]="showUserDetailDialog" 
          [modal]="true" 
          [style]="{width: '680px'}" 
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          styleClass="user-detail-dialog-pro">
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-id-card" style="font-size: 1.5rem; color: #3498db; margin-right: 12px;"></i>
      <div>
        <h3 style="margin: 0; color: #2c3e50; font-size: 1.3rem;">Profil utilisateur</h3>
        <p style="margin: 4px 0 0 0; color: #6c757d; font-size: 0.85rem;">Informations détaillées du compte</p>
      </div>
    </div>
  </ng-template>
  
  <ng-template pTemplate="content">
    <div *ngIf="selectedUser" class="user-profile-pro">
      
      <!-- En-tête profil avec avatar -->
      <div class="profile-header-pro">
        <div class="profile-avatar-large" [class]="selectedUser.role">
          {{ getInitials(selectedUser.username || selectedUser.email) }}
        </div>
        <div class="profile-identity">
          <h2 class="profile-name">{{ getUsername(selectedUser) }}</h2>
          <div class="profile-email-badge">
            <i class="pi pi-envelope"></i>
            <a [href]="'mailto:' + selectedUser.email">{{ selectedUser.email }}</a>
          </div>
          <div class="profile-tags">
            <p-tag [value]="getRoleLabel(selectedUser.role)" 
                   [severity]="getRoleSeverity(selectedUser.role)"
                   [rounded]="true"></p-tag>
            <p-tag [value]="selectedUser.is_active ? 'Actif' : 'Suspendu'" 
                   [severity]="selectedUser.is_active ? 'success' : 'danger'"
                   [rounded]="true"></p-tag>
          </div>
        </div>
      </div>

      <!-- Grille d'informations -->
      <div class="profile-grid">
        <!-- Section Informations personnelles -->
        <div class="profile-section">
          <div class="profile-section-title">
            <i class="pi pi-user"></i>
            <span>Informations personnelles</span>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">ID</div>
            <div class="profile-field-value mono">{{ selectedUser.id }}</div>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">Nom d'utilisateur</div>
            <div class="profile-field-value">{{ selectedUser.username || 'Non défini' }}</div>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">Téléphone</div>
            <div class="profile-field-value">
              <span *ngIf="selectedUser.telephone; else noPhoneDetail" style="display: flex; align-items: center;">
                <i class="pi pi-phone" style="color: #27ae60; margin-right: 6px;"></i>
                {{ selectedUser.telephone }}
                <app-ringover-widget [telephone]="selectedUser.telephone"></app-ringover-widget>
              </span>
              <ng-template #noPhoneDetail>
                <span class="text-muted-pro">Non renseigné</span>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Section Accès et intégrations -->
        <div class="profile-section">
          <div class="profile-section-title">
            <i class="pi pi-cog"></i>
            <span>Accès &amp; Intégrations</span>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">Rôle</div>
            <div class="profile-field-value">
              <p-tag [value]="getRoleLabel(selectedUser.role)" 
                     [severity]="getRoleSeverity(selectedUser.role)"></p-tag>
            </div>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">HubSpot ID</div>
            <div class="profile-field-value">
              <span *ngIf="selectedUser.hubspot_id; else noHubspotDetail" class="hubspot-badge-pro">
                <i class="pi pi-database"></i>
                {{ selectedUser.hubspot_id }}
              </span>
              <ng-template #noHubspotDetail>
                <span class="text-muted-pro">Non connecté</span>
              </ng-template>
            </div>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">Date de création</div>
            <div class="profile-field-value">
              <i class="pi pi-calendar" style="color: #8b5cf6; margin-right: 6px;"></i>
              {{ formatDate(selectedUser.createdAt) }}
            </div>
          </div>
          <div class="profile-field">
            <div class="profile-field-label">Statut du compte</div>
            <div class="profile-field-value">
              <span class="status-indicator" [class.active]="selectedUser.is_active" [class.suspended]="!selectedUser.is_active">
                <i [class]="selectedUser.is_active ? 'pi pi-check-circle' : 'pi pi-ban'"></i>
                {{ selectedUser.is_active ? 'Compte actif' : 'Compte suspendu' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-custom">
      <p-button label="Fermer" 
                icon="pi pi-times" 
                (onClick)="closeUserDetailDialog()" 
                styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Modifier" 
                icon="pi pi-pencil" 
                (onClick)="editUser(selectedUser!)" 
                styleClass="p-button-warning"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog d'édition utilisateur - Design professionnel -->
<p-dialog [(visible)]="showEditUserDialog" 
          [modal]="true" 
          [style]="{width: '620px'}" 
          [closable]="true"
          [draggable]="false"
          [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-user-edit" style="font-size: 1.5rem; color: #e67e22; margin-right: 12px;"></i>
      <div>
        <h3 style="margin: 0; color: #2c3e50; font-size: 1.3rem;">Modifier l'utilisateur</h3>
        <p style="margin: 4px 0 0 0; color: #6c757d; font-size: 0.85rem;">Mettre à jour les informations du compte</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <form [formGroup]="editUserForm" (ngSubmit)="updateUser()" class="modern-form">
      <div class="form-grid">
        <!-- Section Informations personnelles -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-id-card"></i>
            <span>Informations personnelles</span>
          </div>
          
          <div class="field-with-icon">
            <label for="edit_username" class="field-label">
              <i class="pi pi-user"></i>
              Nom d'utilisateur *
            </label>
            <input pInputText 
                   id="edit_username" 
                   formControlName="username" 
                   placeholder="Ex: jean.dupont"
                   class="input-with-icon" />
            <small *ngIf="editUserForm.get('username')?.errors?.['required'] && editUserForm.get('username')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Le nom d'utilisateur est obligatoire
            </small>
            <small *ngIf="editUserForm.get('username')?.errors?.['minlength'] && editUserForm.get('username')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Minimum 3 caractères requis
            </small>
          </div>
          
          <div class="field-with-icon">
            <label for="edit_email" class="field-label">
              <i class="pi pi-envelope"></i>
              Email professionnel *
            </label>
            <input pInputText 
                   id="edit_email" 
                   formControlName="email" 
                   type="email" 
                   placeholder="exemple@entreprise.com"
                   class="input-with-icon" />
            <small *ngIf="editUserForm.get('email')?.errors?.['required'] && editUserForm.get('email')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> L'email est obligatoire
            </small>
            <small *ngIf="editUserForm.get('email')?.errors?.['email'] && editUserForm.get('email')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Format d'email invalide
            </small>
          </div>

          <div class="field-with-icon">
            <label for="edit_telephone" class="field-label">
              <i class="pi pi-phone"></i>
              Téléphone
            </label>
            <input pInputText 
                   id="edit_telephone" 
                   formControlName="telephone" 
                   type="tel" 
                   placeholder="+33 6 12 34 56 78"
                   class="input-with-icon" />
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Numéro de contact optionnel
            </small>
          </div>
        </div>

        <!-- Section Sécurité -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-lock"></i>
            <span>Sécurité et accès</span>
          </div>
          
          <div class="field-with-icon">
            <label for="edit_password" class="field-label">
              <i class="pi pi-key"></i>
              Nouveau mot de passe
            </label>
            <input pInputText 
                   id="edit_password" 
                   formControlName="password" 
                   type="password" 
                   placeholder="Laisser vide pour ne pas changer"
                   class="input-with-icon" />
            <small *ngIf="editUserForm.get('password')?.errors?.['minlength'] && editUserForm.get('password')?.touched" 
                   class="p-error">
              <i class="pi pi-exclamation-circle"></i> Minimum 6 caractères requis
            </small>
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Optionnel — ne remplir que pour modifier
            </small>
          </div>
          
          <div class="field-with-icon">
            <label for="edit_role" class="field-label">
              <i class="pi pi-shield"></i>
              Rôle *
            </label>
            <p-dropdown formControlName="role" 
                        [options]="roleOptions" 
                        optionLabel="label" 
                        optionValue="value"
                        placeholder="Sélectionner un rôle"
                        id="edit_role"
                        [style]="{'width': '100%'}"></p-dropdown>
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Définit les permissions de l'utilisateur
            </small>
          </div>

          <div class="field-with-icon">
            <div class="active-toggle">
              <p-checkbox formControlName="is_active" binary="true" inputId="edit_is_active"></p-checkbox>
              <label for="edit_is_active" class="toggle-label">
                <span class="toggle-text">Compte actif</span>
                <small class="toggle-hint">Décocher pour suspendre l'accès</small>
              </label>
            </div>
          </div>
        </div>

        <!-- Section Intégration -->
        <div class="form-section">
          <div class="section-title">
            <i class="pi pi-link"></i>
            <span>Intégrations</span>
          </div>
          
          <div class="field-with-icon">
            <label for="edit_hubspot_id" class="field-label">
              <i class="pi pi-database"></i>
              ID HubSpot
            </label>
            <input pInputText 
                   id="edit_hubspot_id" 
                   formControlName="hubspot_id" 
                   placeholder="ID de contact HubSpot"
                   class="input-with-icon" />
            <small class="field-hint">
              <i class="pi pi-info-circle"></i> Optionnel — Pour synchronisation CRM
            </small>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-custom">
      <p-button label="Annuler" 
                icon="pi pi-times" 
                (onClick)="closeEditUserDialog()" 
                styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Enregistrer les modifications" 
                icon="pi pi-check" 
                (onClick)="updateUser()" 
                [disabled]="editUserForm.invalid"
                [loading]="updatingUser"
                styleClass="p-button-warning"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Garder tous les dialogs existants... -->
<p-confirmDialog></p-confirmDialog>